import { Ajax } from "../../Common/Ajax";
import { CookieHelper } from "../../Common/CookieHelper";
import { GlobalData } from "../../Common/GlobalData";
import { HtmlHelpers } from "../../Common/HtmlHelpers";
import { TemplateHelpers } from "../../Common/KendoHelpers";

export class AccountHistory {
    public static readonly GRID = '#accountHistoryGrid';

    private static readonly REPORT_DATE = '#closingDate';
    private static readonly START_DATE = '#startDate';

    private grid!: kendo.ui.Grid;

    private static _instance: AccountHistory;
    public static getInstance() {
        return this._instance || (this._instance = new this());
    }

    private constructor() { }

    public init() {
        if (!this.grid) {
            this.initGrid();
        }
        else {
            this.grid.dataSource.read();
        }
    }

    private initGrid() {
        $(AccountHistory.START_DATE).kendoDatePicker();

        const account = CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE);
        const url = GlobalData.URL_BASE +
            GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_ACCOUNT_HISTORY + "?account=" + account;

        this.grid = $(AccountHistory.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: url,
                }
            },
            dataBound: () => {
                const data = $(AccountHistory.GRID).data('kendoGrid')!.dataSource.data();
                if (data && data.length > 0) {
                    $(AccountHistory.REPORT_DATE).html(
                        HtmlHelpers.getFormattedDate(data[0].dateOfEntry));
                }

                // Bind the change event of the start date to refreshing the grid. We
                // wait until the grid data has already been bound so we don't end up
                // doing it twice.
                const datePicker = $(AccountHistory.START_DATE).data('kendoDatePicker')!;
                datePicker.unbind('change').bind('change', () => {
                    this.refreshGrid();
                });

                $(AccountHistory.GRID).show();
            },

            height: 915,
            groupable: false,
            navigatable: true,
            sortable: true,
            filterable: false,
            pageable: false,
            resizable: true,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '6%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '23%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: left; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: "sumQtyOwn",
                    title: "<br />Qty",
                    width: "4%",
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:n0}',
                },
                {
                    field: "sumProceeds",
                    title: "<br />Proceeds",
                    width: '8%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: right; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: right; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "sumCostBasis",
                    title: "<br />CostBasis",
                    width: '8%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: right; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: right; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "sumGainLoss",
                    title: "Gain/Loss$",
                    width: "9%",
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getColorCurrencyTemplate('sumGainLoss')),
                },
                {
                    field: "sumGainLossPct",
                    title: "Gain/Loss%",
                    width: '9%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getColorPercentTemplate('sumGainLossPct')),
                },
                {
                    field: 'term',
                    title: '<BR />Term',
                    width: '5%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'washSale',
                    title: 'Wash<BR />Sale?',
                    width: '5%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getBoolTemplate('washSale')),
                },
                {
                    field: 'lotNo',
                    title: 'Lot<BR />No.',
                    width: '5%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:n0}',
                },
                {
                    field: "closedDate",
                    title: "Closed<BR />Date",
                    width: '8%',
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px; font-weight: normal" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('closedDate')),
                },
                {
                    field: "openedDate",
                    title: "Opened<BR />Date",
                    width: '8%',
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px; font-weight: normal" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('openedDate')),
                },
                {
                    field: 'valueLine',
                    title: 'PDF<BR />Report',
                    width: '6%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
            ]
        }).data('kendoGrid')!;
    }

    private refreshGrid() {
        const datePicker = $(AccountHistory.START_DATE).data('kendoDatePicker')!;
        const startDate = HtmlHelpers.getFormattedDate(datePicker.value().toDateString());
        const account = CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE);
        const urlSuffix = GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_ACCOUNT_HISTORY +
            '?startDate=' + startDate + "&account=" + account;

        const success = (data: any) => {
            this.grid.setDataSource(new kendo.data.DataSource({ data: data }));
        };

        const error = () => {
            // TODO_CAB: what to do on error?
        }

        Ajax.invoke(urlSuffix, 'GET', null, success, error);
    }
}
